import { ClientSessionStageTypes } from "@hooks/dtos/IClientSessionDTO";

export const clientIsValidStage = (
  stage: ClientSessionStageTypes | undefined,
  stages: ClientSessionStageTypes[],
): Boolean => {
  if (!stage && stages.length > 0) return false;
  if (stage && stages.length > 0 && !stages.includes(stage)) return false;
  return true;
};
